import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Measure, { ContentRect } from "react-measure";
import { FlyerDetailAddPageTemplateOption } from "../flyer-detail-add-page-template-option/flyer-detail-add-page-template-option.component";
import {
  minHeight,
  useFlyerDetailPageFormTemplateGroupStyles,
} from "./flyer-detail-add-page-template-group.styles";
import { FlyerTemplateSummary } from "../../../../../../features/flyer-template/types/flyer-template-summary.interface";
import { FlyerDetailAddPageTemplateGroupProps } from "./flyer-detail-add-page-template-group.props";
import { FlyerDetailAddPageTemplateGroupHeader } from "../flyer-detail-add-page-template-group-header/flyer-detail-add-page-template-group-header.component";

export const FlyerDetailAddPageTemplateGroup = (props: FlyerDetailAddPageTemplateGroupProps) => {
  const classes = useFlyerDetailPageFormTemplateGroupStyles();
  const [groupHeight, setGroupHeight] = useState<number>(minHeight);

  const disabled = () => groupHeight <= minHeight;
  const expandIcon = () => (disabled() ? null : <ExpandMoreIcon />);

  const onResize = (contentRect: ContentRect) =>
    setGroupHeight(contentRect?.bounds?.height ?? minHeight);

  return (
    <Accordion className={classes.accordion} disabled={disabled()} elevation={0} square>
      <AccordionSummary expandIcon={expandIcon()}>
        <FlyerDetailAddPageTemplateGroupHeader templateGroup={props.templateGroup} />
      </AccordionSummary>
      <Measure bounds onResize={onResize}>
        {({ measureRef }) => (
          <AccordionDetails className={classes.templates} ref={measureRef}>
            {props.templateGroup.templates.map((template: FlyerTemplateSummary) => (
              <FlyerDetailAddPageTemplateOption
                key={template.id}
                template={template}
                onEnter={props.onEnter}
              />
            ))}
          </AccordionDetails>
        )}
      </Measure>
    </Accordion>
  );
};
